document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.js-to-top');

  if (!btn) return;

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
});
